import api from "../api";
import { errorManager } from "../util";

export const ADD_CASE_SUCCESS = 'ADD_CASE_SUCCESS';
export const ADD_CASE_FAILURE = 'ADD_CASE_FAILURE';

export const INSERT_DOCUMENT_SUCCESS = 'INSERT_DOCUMENT_SUCCESS';
export const INSERT_DOCUMENT_FAILURE = 'INSERT_DOCUMENT_FAILURE';

//Actions
export const AddCaseSuccess = (value) => {
    return {
        type: ADD_CASE_SUCCESS,
        payload: value
    }
}

export const AddCaseFailure = (value) => {
    return {
        type: ADD_CASE_FAILURE,
        payload: value
    }
}

export const AddCase = (row, callBack) => {
    document.body.className = 'loading';

    return (dispach) => {
        api.post("/Casos/Add", row).then(response => {
            //console.log(response.data);
            dispach(AddCaseSuccess(row));
            if (callBack !== undefined) {
                callBack(response.data, null);
            }
            document.body.className = '';
        }).catch(error => {
            //console.log(error);
            dispach(AddCaseFailure(error));
            if (callBack !== undefined) {
                callBack(null, error);
            }
            document.body.className = '';
        });
    }
}

export const ComentarCaso = (row, callBack) => {
    document.body.className = 'loading';

    return (dispach) => {
        api.post("/Casos/Comments", row).then(response => {
            //console.log(response.data);
            if (callBack !== undefined) {
                callBack(response.data, null);
            }
            document.body.className = '';
        }).catch(error => {
            //console.log(error);
            if (callBack !== undefined) {
                callBack(null, error);
            }
            document.body.className = '';
            errorManager(error);
        });
    }
}

export const AddDocumentacionCaso = async (row, callBack) => {
    document.body.className = 'loading';

    let file = await api.post("/Casos/AddDocuments", row).then(response => {
        if (callBack !== undefined) {
            callBack(response.data, null);
        }
        
        document.body.className = '';
    }).catch(error => {
        if (callBack !== undefined) {
            callBack(null, error);
        }

        document.body.className = '';
        errorManager(error);
    });
    
    return file;
}

export default AddCase;